<template>
  <div class="diversity-overtime-stats-wrap">
    <div class="first-row">
      <div class="diversity-score" v-if="statsData.overall">
        {{statsData.overall.toFixed(2)}}
      </div>
      <div class="diversity-score" v-else>
        --
      </div>
      <div class="diversity-sub">
        Overall participation rate in {{user.company_name}}
      </div>
    </div>
    <div class="second-row">
      <div class="diversity-score" v-if="statsData.male">
        {{statsData.male.toFixed(2)}}
      </div>
      <div class="diversity-score" v-else>
        --
      </div>
      <div class="diversity-sub">
        Overall participation rate of male
      </div>
    </div>
    <div class="third-row">
      <div class="diversity-score" v-if="statsData.female">
        {{statsData.female.toFixed(2)}}
      </div>
      <div class="diversity-score" v-else>
        --
      </div>
      <div class="diversity-sub">
        Overall participation rate of female
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'DiversityOvertimeStats',
  props: {
    statsData: {
      required: true,
      type: Object
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  }
  // watch: {
  //   statsData: {
  //     deep: true,
  //     immediate: true,
  //     handler () {
  //       this.formatDriverData();
  //     }
  //   }
  // }
};
</script>

<style lang="scss" scoped>
.diversity-overtime-stats-wrap {
  display: grid;
  grid-template-columns: 1fr;
  padding-left: 20px;
  .first-row, .second-row, .third-row{
    display: grid;
    grid-template-columns: 1.5fr 3fr;
    align-items: center;
    .diversity-score {
      font-size: 50px;
    }
  }
}
</style>
